<template>
  <rest-list-column
    :prop="prop"
    :title="title"
    :route="route"
    :width="width"
    :min-width="minWidth"
    :formatter="formatter"
    :filter-date-range="isRange"
    :filter-date="!isRange"
    :date-picker-props="datePickerProps"
    :sortable="sortable"
    :fixed="fixed"
    :filterable="filterable"
    :convert-to-utc="convertToUtc"
  />
</template>

<script>
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectTimezoneDate, isDateFormat } from '@/core/helpers'
import { projectTimezoneTimestamp } from '../../../core/helpers'

export default {
  name: 'RestListColumnDate',

  components: { RestListColumn },

  props: {
    prop: {
      type: String,
      required: true
    },

    unix: {
      type: Boolean,
      default: true
    },

    title: {
      type: String,
      required: true
    },

    readonly: {
      type: Boolean,
      default: false
    },

    route: {
      type: Function,
      required: false
    },

    width: {
      type: Number,
      required: false
    },

    minWidth: {
      type: Number,
      required: false,
      default: 180
    },

    dateFormat: {
      type: String,
      required: false,
      default: 'DD MMM YYYY HH:mm:ss'
    },

    datePickerProps: {
      type: Object,
      required: false,
      default: () => {
        return {
          type: 'datetimerange',
          value_format: 'yyyy-MM-dd HH:mm:ss',
          default_time: ['00:00:00', '23:59:59']
        }
      }
    },

    sortable: {
      required: false
    },

    fixed: {
      type: [Boolean, String],
      required: false,
      default: false
    },

    filterable: {
      type: Boolean,
      default: true
    },

    isRange: {
      type: Boolean,
      required: false,
      default: true
    },

    // Pass-through to control timezone conversion behavior in filter component
    convertToUtc: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    formatter(value) {
      if (isDateFormat(value)) {
        return value
      }

      if (value) {
        if (this.unix) {
          // if value is in milliseconds, convert to seconds
          if (value > 1e12) {
            value = Math.floor(value / 1000)
          }
          return projectTimezoneDate(value).format(this.dateFormat)
        }

        return projectTimezoneTimestamp(value).format(this.dateFormat)
      }

      return '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListColumnDate.vue